import { PreOrderStatuses } from "@features/pre-order/domain";

export const preOrderAPI = {
  list: "/api/pre-orders",
  listProducts: "/preorder/products",
  listUpcomingRequests: "/v3/preorder/requests",
  listRequests: "/v3/preorder/requests",
  createPreOrderRequest: "/pre-orders/requests",
  createExternalProductPreOrderRequest: "/preorder/external-request",
  listSummary: "/preorder/requests/summary",
  rejectPreOrderRequest: (requestId: string): string =>
    `/preorder/requests/${encodeURIComponent(requestId)}/reject-down-payment`,
  acceptPreOrderOffer: (requestId: string): string =>
    `/v2/preorder/requests/${encodeURIComponent(requestId)}/accept-down-payment`,
} as const;

export const preOrderTrackEvents = {
  viewPage: "Preorder-page-load",
  clickScrollToPreOrderProducts: "new_pre_order_top_banner_button_clicked",
  clickScrollToPreOrderExternalProducts:
    "click_scroll_to_pre_order_external_products",
  clickPreOrderProductsTab: "click_pre_order_products_tab",
  clickPreOrderExternalProductsTab: "click_pre_order_external_products_tab",
  clickPreOrderExternalProductOpenForm:
    "click_pre_order_external_product_open_form",
  submitPreOrderExternalProductForm: "submit_pre_order_external_product_form",
};

export const ALLOWED_PRE_ORDER_STATUSES = [
  PreOrderStatuses.STARTED,
  PreOrderStatuses.PENDING_APPROVAL,
  PreOrderStatuses.MONEY_TRANSFERRED_APPROVED,
  PreOrderStatuses.PENDING_EXTERNAL_PRODUCT_APPROVAL,
  PreOrderStatuses.COMPLETE,
];

export const BANK_TRANSFER_DATA = {
  iban: "EG560010009200000100045280197",
  accountNumber: "100045280197",
  swift: "CIBEEGCXXXX",
  name: "TAGER FOR ELECTRONIC TRADE",
  bankName: "CIB",
} as const;

export const DELIVERY_RATES = {
  firstMilestone: 30,
  firstMilestoneRefund: 50,
  secondMilestone: 70,
  secondMilestoneRefund: 100,
  depositPercentage: 30,
} as const;

export const DELIVERY_TIMES = {
  china: {
    min: 20,
    max: 25,
  },
  emirates: {
    min: 7,
    max: 10,
  },
  localMarket: {
    min: 2,
    max: 3,
  },
} as const;
